"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STATE_STORE_KEY_PREFIX = void 0;
exports.generateStateQueryParamValue = generateStateQueryParamValue;
exports.getIsStatQueryParamValue = getIsStatQueryParamValue;
exports.getKey = getKey;
exports.clearStateStore = clearStateStore;
exports.getStateData = getStateData;
exports.markStateDataAsProcessedByCallback = markStateDataAsProcessedByCallback;
var tsafe_1 = require("../vendor/frontend/tsafe");
var generateUrlSafeRandom_1 = require("../tools/generateUrlSafeRandom");
var STATE_QUERY_PARAM_VALUE_IDENTIFIER_PREFIX = "b2lkYy1zcGEu";
var RANDOM_STRING_LENGTH = 32 - STATE_QUERY_PARAM_VALUE_IDENTIFIER_PREFIX.length;
function generateStateQueryParamValue() {
    return "".concat(STATE_QUERY_PARAM_VALUE_IDENTIFIER_PREFIX).concat((0, generateUrlSafeRandom_1.generateUrlSafeRandom)({
        length: RANDOM_STRING_LENGTH
    }));
}
function getIsStatQueryParamValue(params) {
    var maybeStateQueryParamValue = params.maybeStateQueryParamValue;
    return (maybeStateQueryParamValue.startsWith(STATE_QUERY_PARAM_VALUE_IDENTIFIER_PREFIX) &&
        maybeStateQueryParamValue.length ===
            STATE_QUERY_PARAM_VALUE_IDENTIFIER_PREFIX.length + RANDOM_STRING_LENGTH);
}
exports.STATE_STORE_KEY_PREFIX = "oidc.";
function getKey(params) {
    var stateQueryParamValue = params.stateQueryParamValue;
    return "".concat(exports.STATE_STORE_KEY_PREFIX).concat(stateQueryParamValue);
}
function getStateStore(params) {
    var stateQueryParamValue = params.stateQueryParamValue;
    var item = localStorage.getItem(getKey({ stateQueryParamValue: stateQueryParamValue }));
    if (item === null) {
        return undefined;
    }
    var obj = JSON.parse(item);
    (0, tsafe_1.assert)((0, tsafe_1.typeGuard)(obj, obj instanceof Object && obj.data instanceof Object && typeof obj.data.context === "string"));
    return obj;
}
function setStateStore(params) {
    var stateQueryParamValue = params.stateQueryParamValue, obj = params.obj;
    localStorage.setItem(getKey({ stateQueryParamValue: stateQueryParamValue }), JSON.stringify(obj));
}
function clearStateStore(params) {
    var stateQueryParamValue = params.stateQueryParamValue;
    localStorage.removeItem(getKey({ stateQueryParamValue: stateQueryParamValue }));
}
function getStateData(params) {
    var stateQueryParamValue = params.stateQueryParamValue;
    var stateStore = getStateStore({ stateQueryParamValue: stateQueryParamValue });
    if (stateStore === undefined) {
        return undefined;
    }
    return stateStore.data;
}
function markStateDataAsProcessedByCallback(params) {
    var stateQueryParamValue = params.stateQueryParamValue;
    var obj = getStateStore({ stateQueryParamValue: stateQueryParamValue });
    (0, tsafe_1.assert)(obj !== undefined);
    (0, tsafe_1.assert)(obj.data.context === "redirect");
    obj.data.hasBeenProcessedByCallback = true;
    setStateStore({ stateQueryParamValue: stateQueryParamValue, obj: obj });
}
//# sourceMappingURL=StateData.js.map